import React from 'react'
import styles from './CategoryFilter.module.scss'

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className={styles.filter}>
      <button
        className={`${styles.categoryButton} ${!activeCategory ? styles.active : ''}`}
        onClick={() => onCategoryChange(null)}
      >
        Все категории
      </button>
      
      {categories.map((category) => (
        <button
          key={category.id}
          className={`${styles.categoryButton} ${activeCategory === category.id ? styles.active : ''}`}
          onClick={() => onCategoryChange(category.id)}
        >
          {category.name}
        </button>
      ))}
    </div>
  )
}

export default CategoryFilter